<div class="section-header">
    <div class="title">
        Bezugsinformationen
    </div>
</div>

<div class="fields-table" *ngIf="model">
    <div class="fields-row">
        <div class="label-cell">Bezug über:</div>
        <!--    <div class="field-content">{{model.project.requestedProductInfo.productDistributorId ? model.project.requestedProductInfo.productDistributorId : '-'}}</div>-->
        <div class="field-content distributor-name" [innerHTML]="getCurrentProductDistributorName()"></div>
    </div>
    <div class="fields-row">
        <div class="label-cell">Bezug alternativ über:</div>
        <!--    <div class="field-content">{{model.project.requestedProductInfo.productDistributorId ? model.project.requestedProductInfo.productDistributorId : '-'}}</div>-->
        <div class="field-content distributor-name" [innerHTML]="getCurrentSecondaryDistributorName()"></div>
    </div>
    <div class="fields-row">
        <div class="label-cell">Auslieferungsbeginn:</div>
        <div class="field-content" *ngIf="model.project.requestedProductInfo.rolloutStart else noValue">
            {{model.project.requestedProductInfo.rolloutStart|  date:'dd.MM.yyyy'}}
        </div>
    </div>
    <div class="fields-row">
        <div class="label-cell">Oneshot:</div>
        <div class="field-content">
            {{model.project.requestedProductInfo.isOneshot ? 'Ja' : 'Nein'}}
        </div>
    </div>
    <div class="fields-row">
        <div class="label-cell">Auslieferungsende:</div>
        <div class="field-content" *ngIf="model.project.requestedProductInfo.rolloutEnd else noValue">
            {{model.project.requestedProductInfo.rolloutEnd | date:'dd.MM.yyyy' }}
        </div>
    </div>
</div>

<ng-template #noValue>
    <div class="field-content">-</div>
</ng-template>


<div class="divider"></div>

<app-devices-table-viewer *ngIf="model.isDeviceOrderRequested"
                          [usePriceApprovalMode]="usePriceApprovalMode">
</app-devices-table-viewer>

<ng-container *ngIf="!model.isDeviceOrderRequested">
    <div class="section-header">
        <div class="title">
            Hardware
        </div>
    </div>
    <div class="fields-table">
        <div class="fields-row">
            <div class="label-cell">Ausgewählt:</div>
            <div class="field-content">
                Keine Hardware anfragen
            </div>
        </div>
    </div>
</ng-container>


<div class="divider d1"></div>


<app-additional-items-table-viewer *ngIf="model.isAccessoryOrderRequested"
                                   title="Zubehör"
                                   [tableItems]="model.requestedAccessoryContainers">
</app-additional-items-table-viewer>

<div class="divider d2" *ngIf="model.isAccessoryOrderRequested"></div>


<app-additional-items-table-viewer *ngIf="model.isWarrantyOrderRequested"
                                   title="Full Service Pack"
                                   [tableItems]="model.requestedWarrantyContainers">
</app-additional-items-table-viewer>

<div class="divider d3" *ngIf="model.isWarrantyOrderRequested"></div>


<form *ngIf="model.isDeviceOrderRequested && model.isServiceOrderRequested">
    <app-project-services-table [isViewerMode]="true">
    </app-project-services-table>

    <div class="divider d4"></div>
</form>


<app-additional-items-table-viewer *ngIf="model.isUpgradesOrderRequested"
                                   title="Upgrades"
                                   [tableItems]="model.requestedUpgradesContainers"
                                   [infoIconText]="getUpgradesInfoIconText()">
</app-additional-items-table-viewer>

<div class="divider d5" *ngIf="model.isUpgradesOrderRequested"></div>


